import { version } from "../../package.json";
import posthog from "posthog-js";
import { useAuth } from "@/models/useAuth";

export const initPostHog = () => {
  if (__DEV__) return;

  try {
    if (!useAuth.isAuthenticated()) return;

    const authUser = useAuth.currentAuthUser();

    if (!authUser?.userId) return;

    posthog.set_config({ disable_session_recording: false });

    posthog.identify(authUser?.userId, {
      email: authUser?.email,
      ip: authUser?.ip,
      country: authUser?.country,
      appVersion: version,
    });
  } catch (error) {
    console.error("Error initializing PostHog", error);
  }
};

export const logger = {
  error: (message: string, error?: Record<string, any>) => {
    if (__DEV__) return;

    posthog.captureException(new Error(message), {
      message,
      error,
    });
  },
  info: (message: string, properties?: Record<string, any>) => {
    if (__DEV__) return;

    posthog.capture(message, properties);
  },
};
